import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// import { scan } from "react-scan"; // must be imported before React and React DOM
// import * as Sentry from "@sentry/react";


// Sentry.init({
//   dsn: "https://f2cf8e8dc91c3a08fee28e278488d026@o4509584466116608.ingest.us.sentry.io/4509584467230720",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
//   integrations: [
//     Sentry.replayIntegration(),
//     Sentry.reactRouterV6BrowserTracingIntegration({
//       useEffect: React.useEffect,
//       useLocation,
//       useNavigationType,
//       createRoutesFromChildren,
//       matchRoutes,
//     }),
//     // Sentry.feedbackIntegration({
//     //   colorScheme: "system",
//     //   isEmailRequired: true,
//     // }),
//     // Send console.log, console.error, and console.warn calls as logs to Sentry
//     Sentry.consoleLoggingIntegration({ levels: ["log", "error", "warn", "debug"] }),
//   ],
//   // Enable structured logs
//   _experiments: {
//     enableLogs: true,
//   },
//   // Session Replay
//   replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
//   environment: import.meta.env.MODE,
// });



// if (import.meta.env.DEV) {
//   scan({
//     enabled: true,
//   });
// }

createRoot(document.getElementById("root")!).render(<App />);
